var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarAdminIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "0is1sconma",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kkvvkwtctb",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 5.333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0F1941",
    xlinkHref: "#0is1sconma"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "qrbg59vsfc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kkvvkwtctb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.773 5.94c1.753-.71 2.887-1.523 3.399-2.44.763.98 1.947 1.801 3.554 2.466 1.606.664 3.781 1.23 6.524 1.7v13.597H5.875V7.667c2.845-.442 5.144-1.018 6.898-1.728zM5.875 21.262H26.25c-1.338 1.79-2.43 3.024-3.272 3.7-2.937 2.358-5.936 3.537-6.806 3.537-.874 0-3.922-1.19-6.954-3.569-.857-.672-1.971-1.895-3.343-3.668z",
    fill: "#FFB511",
    mask: "url(#qrbg59vsfc)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F5F0",
    fillRule: "nonzero",
    mask: "url(#qrbg59vsfc)",
    d: "m16.172 18.85-3.09 1.627.59-3.444-2.5-2.44 3.455-.503 1.545-3.134 1.545 3.134 3.456.503-2.5 2.44.59 3.444z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarAdminIcon);
export default __webpack_public_path__ + "static/media/SideBarAdminIcon.05688be2.svg";
export { ForwardRef as ReactComponent };